import React from 'react';

class TruckImage extends React.Component {
	constructor(props) {
		super(props)
		this.truck = this.props.truck;
	}

	drawTruck(truck) {
		let axleGroups = truck.calculateAxleGroups();
		let truckImage = [];
		truckImage.push(
			<div>
				<div className='cabinImage'>
					<img src={'img/Steering.png'}/>
					<span className='cabinImage__axle'>1</span>
				</div>
			</div>
		)

		for (let axleGroup = 0; axleGroup < axleGroups.startAxle.length; ++axleGroup) {
			// {0, 3} and {2, 4}
			for (let axle = axleGroups.startAxle[axleGroup]; axle <= axleGroups.endAxle[axleGroup]; ++axle) {
				// skip over the first tire
				if (axle > 0) {
					let truckTireAndBridge = [];
					let truckTireAndBridgeLabel = [];
					// print the associated bridges before the tire
					for (let singleBridgeAxle = 0; singleBridgeAxle < (((truck.feet[axle] * 12) + truck.inches[axle]) / 4); ++singleBridgeAxle) {
						truckTireAndBridge.push(<img src={'img/Bridge.png'} />);
					}
					// print either 2 or 4 tires
					truckTireAndBridge.push(
						<span className='tireImage'>
							<img src={'img/Single_' + truck.tireCount[axle] + '.png'} />
							<span className='tireImage__axle'>{axle + 1}</span>
						</span>
					);

					// create labels for bridge lengths
					truckTireAndBridgeLabel.push(<span>{truck.feet[axle]}'{truck.inches[axle]}"</span>);

					// add the tire and bridge to the image
					truckImage.push(
						<div className=''>
							<div className='tireAndBridgeImage'>{truckTireAndBridge}</div>
							<div>{truckTireAndBridgeLabel}</div>
						</div>
					);
				}
			}
		}
		console.log(truckImage);
		return truckImage;
	}

	drawLabels(truck) {

		return;
	}

	render() {
		return (
			<div className='truckImage'>
				{this.drawTruck(this.truck)}
			</div>
			
			//<div>
			//	{this.drawTruck(this.truck)}
			//</div>
		);
	}
}

export default TruckImage;


// WEBPACK FOOTER //
// ./src/Minnesota/MNOutput/TruckImage.js